import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
} from '@mui/material'

/**
 * Reusable MUI Confirmation Dialog
 * Replaces window.confirm() which is unreliable in production browser environments.
 *
 * @param {boolean}  open       - Whether the dialog is visible
 * @param {string}   title      - Dialog title
 * @param {string}   message    - Confirmation message body
 * @param {string}   confirmText - Label for the confirm button (default: "Delete")
 * @param {string}   cancelText  - Label for the cancel button (default: "Cancel")
 * @param {string}   color      - MUI color for confirm button (default: "error")
 * @param {function} onConfirm  - Called when user confirms
 * @param {function} onCancel   - Called when user cancels
 */
const ConfirmDialog = ({
    open,
    title = 'Confirm',
    message = 'Are you sure?',
    confirmText = 'Delete',
    cancelText = 'Cancel',
    color = 'error',
    onConfirm,
    onCancel,
}) => {
    return (
        <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
            <DialogTitle sx={{ color: color === 'error' ? 'error.main' : color === 'success' ? 'success.main' : 'primary.main' }}>
                {title}
            </DialogTitle>
            <DialogContent>
                <Typography>{message}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>{cancelText}</Button>
                <Button onClick={onConfirm} color={color} variant="contained">
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmDialog
